import { queryOptions } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import type { ID } from '#shared/index'
import { getMessagePosition } from '../api/get-message-position'

export const getMessagePositionQueryKey = (chatId: MaybeRef<ID>, messageId: MaybeRef<ID>) => [
  'message-position',
  chatId,
  messageId,
]

export const getMessagePositionQueryOptions = (chatId: MaybeRef<ID>, messageId: MaybeRef<ID>) =>
  queryOptions({
    queryKey: getMessagePositionQueryKey(chatId, messageId),
    queryFn: () => getMessagePosition(unref(chatId), unref(messageId)),
    staleTime: Infinity,
    gcTime: 600_000,
  })
